export default __webpack_public_path__ + "static/media/_A6A9833.e0afb49f.jpg";